import type { Source } from "@types"

/**
 * Résout le segment TURPE (C5, C4, P3, etc.) pour le filtrage éligibilité Optim TURPE.
 * L’API ne le remplit pas toujours sur `source.segment` : le chemin Enedis usuel est
 * `informations.pdl.compteur.segment`.
 */
export function getSourceSegmentForOptim(source: Source): string {
    const normalizeSegment = (value: unknown): string =>
        String(value).trim().toUpperCase()

    const top = (source as { segment?: string | null }).segment
    if (top != null && String(top).trim() !== "") {
        return normalizeSegment(top)
    }
    if (source.type === "pdl") {
        const fromPdl = source.informations?.pdl?.compteur?.segment
        if (fromPdl != null && String(fromPdl).trim() !== "") {
            return normalizeSegment(fromPdl)
        }
    }
    return ""
}
